import { useState, useEffect, useCallback } from 'react';

interface ContextMenuState {
    x: number;
    y: number;
    visible: boolean;
}

export function useContextMenu() {
    const [menu, setMenu] = useState<ContextMenuState>({ x: 0, y: 0, visible: false });

    const showMenu = useCallback((e: React.MouseEvent | React.TouchEvent | React.PointerEvent | MouseEvent | TouchEvent) => {
        // Prevent default context menu
        if ('preventDefault' in e) {
            e.preventDefault();
        }

        let x = 0;
        let y = 0;

        if ('clientX' in e) {
            x = (e as MouseEvent).clientX;
            y = (e as MouseEvent).clientY;
        } else if ('touches' in e && (e as TouchEvent).touches.length > 0) {
            x = (e as TouchEvent).touches[0].clientX;
            y = (e as TouchEvent).touches[0].clientY;
        }

        setMenu({ x, y, visible: true });
    }, []);

    const hideMenu = useCallback(() => {
        setMenu(prev => ({ ...prev, visible: false }));
    }, []);

    useEffect(() => {
        const handleClick = () => hideMenu();
        const handleScroll = () => hideMenu();

        if (menu.visible) {
            window.addEventListener('click', handleClick);
            window.addEventListener('scroll', handleScroll);
        }

        return () => {
            window.removeEventListener('click', handleClick);
            window.removeEventListener('scroll', handleScroll);
        };
    }, [menu.visible, hideMenu]);

    return { menu, showMenu, hideMenu };
}
